export default __webpack_public_path__ + "static/media/icon-content-contract-24-px.d968d244.svg";